module.exports = __webpack_public_path__ + "static/media/PlotMarker.b45dcfa1.jpg";